import { render, staticRenderFns } from "./DataProcessorAgreement.vue?vue&type=template&id=2477df08&"
import script from "./DataProcessorAgreement.vue?vue&type=script&lang=js&"
export * from "./DataProcessorAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports